import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import appConfig from 'utils/config/appConfig'

const GTM_SCRIPT_ID = 'fero-register-gtm-script'

const isRegisterRoute = (pathname) =>
  pathname === appConfig.gtmRegisterPath ||
  pathname.startsWith(`${appConfig.gtmRegisterPath}/`)

const GoogleTagManager = () => {
  const {pathname} = useLocation()

  useEffect(() => {
    if (!appConfig.gtmId || !isRegisterRoute(pathname) || window.__feroGtmLoaded) {
      return
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    })

    const script = document.createElement('script')
    script.id = GTM_SCRIPT_ID
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${appConfig.gtmId}`

    document.head.appendChild(script)
    window.__feroGtmLoaded = true
  }, [pathname])

  return null
}

export default GoogleTagManager
